/*
 * Module for the Irs 1099 Extract job criteria page
 */
rs.module("jobs/criteria/irs1099extract",

    [
        "controls/data/grid",
        "common/visibility"
    ],

    function (gridModule, visibility) {

        // Global variable to skip grid's first execution
        var _executeSelectionChanged;

        // Initialize the page
        function initialize(jsSelectors, urls, lrsGridApi, modes, searchControl) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var modeSelect = criteria.js(jsSelectors.modeSelect);
            var taxYearSelect = criteria.js(jsSelectors.taxYearSelect);
            var individualSection = criteria.js(jsSelectors.individualSection);
            var searchLoadingSpinner = criteria.js(jsSelectors.searchLoadingSpinner);

            // individual mode jsSelectors
            var gridSection = criteria.js(jsSelectors.gridSection);
            var gridErrorMessage = criteria.js(jsSelectors.gridErrorMessage);
            var informationIcon = criteria.js(jsSelectors.informationIcon);
            var reExtractLoadingSpinner = criteria.js(jsSelectors.reExtractLoadingSpinner);
            var includeCorrectionFlags = criteria.js(jsSelectors.includeCorrectionFlags, { multiple: true });

            // Setup event listeners
            modeSelect.change(onModeSelectChange);
            taxYearSelect.change(initializeReExtractOptions);
            lrsGridApi.selectionChanged(onGridSelectionChange);

            // On Mode Select Change
            function onModeSelectChange() {

                // De-select checkboxes on mode select change
                includeCorrectionFlags.prop('checked', false);

                // Individual specific actions
                if (modeSelect.val() == modes.individual) {
                    visibility.show(individualSection);
                }

                // Full specific actions
                if (modeSelect.val() == modes.full) {
                    visibility.hide(individualSection);
                    lrsGridApi.selectedValues = null;
                }

                // Retrieve ReExtract Flag, and diplsay re-extract options accordingly
                initializeReExtractOptions();
            }

            // On grid selection change
            function onGridSelectionChange(values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged) {

                    if (values.length > 0) {
                        initializeReExtractOptions();
                    }
                    else {
                        visibility.hide(informationIcon);
                        includeCorrectionFlags.prop("disabled", true);
                    }

                    // Clear validation message
                    clearGridValidationMessage();
                }

                _executeSelectionChanged = true;
            }

            // Listen for a person to be selected from the search control
            searchControl.onSelectionComplete(function (accountPartyKey) {
                updateGrid(accountPartyKey);
            });

            // Listen for search selection to be removed
            searchControl.onSelectionCleared(function () {

                // reset and hide grid selection
                lrsGridApi.selectedValues = null;
                visibility.hide(gridSection);

                // reset re-extract flags
                initializeReExtractOptions();
            });

            // Populate grid after selecting a person from the search control
            function updateGrid(accountPartyKey) {

                searchLoadingSpinner.show();

                // Update the grid using the selected account party key
                gridModule.update(
                    urls.getBenefitClaimPaymentsUrl,

                    { accountPartyKey: accountPartyKey },

                    lrsGridApi.agGridApi,

                    function done() {

                        searchLoadingSpinner.hide();
                        visibility.show(gridSection);
                    }
                );
            }

            // Retrieve new re-extract flag and set correction section visiblity
            function initializeReExtractOptions() {

                // Tax Year must have a value before any retrieve
                if (taxYearSelect.val()) {

                    if (modeSelect.val() == modes.full) {
                        getReExtractFlag();
                    }

                    // If mode is individual, we need to ensure both a BCP and a Tax Year are selected before calculating.
                    if (modeSelect.val() == modes.individual) {

                        if (lrsGridApi.selectedValues.length > 0) {
                            getReExtractFlag();
                        }
                        else {
                            visibility.hide(informationIcon);
                            includeCorrectionFlags.prop("disabled", true);
                        }
                    }
                }
            }

            // Retrieve ReExtract Flag data
            function getReExtractFlag() {

                // Retrieve the selected benefit claim payment key if individual.
                var selectedBenefitClaimPaymentKey;
                if (modeSelect.val() == modes.individual) {
                    selectedBenefitClaimPaymentKey = lrsGridApi.selectedValues;
                }

                // Show loading icon
                reExtractLoadingSpinner.show();

                // Retrieve ReExtract Flag data
                $.getJSON(urls.getReExtractFlagUrl, { taxYear: taxYearSelect.val(), bcpKey: parseInt(selectedBenefitClaimPaymentKey) }).done(function (data) {

                    // Enable/Disable correction flags
                    includeCorrectionFlags.prop("disabled", !data.flag);

                    // Show / Hide information icons
                    if (data.flag) {
                        visibility.hide(informationIcon);
                    }
                    else {
                        visibility.show(informationIcon);
                        includeCorrectionFlags.prop('checked', false);
                    }

                    // hide loading spinner
                    reExtractLoadingSpinner.hide();
                });
            }

            // For some reason, selecting a BCP does not clear the error message, so doing here manually.
            function clearGridValidationMessage() {
                gridErrorMessage.text('');
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);